import axios from 'axios';
import Constants from './constants';
import { Cookies } from 'react-cookie';
const cookies = new Cookies();

const authAxios = axios.create({
	baseURL: Constants.API_BASE_URL,
	timeout: 300000
});

authAxios.defaults.withCredentials = true;

// authAxios.interceptors.request.use(
// 	request => {
// 		request.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
// 		return request;
// 	},
// 	error => Promise.reject(error)
// );

authAxios.interceptors.response.use(
	response => response,
	error => {
		if (error.response?.status === 401) {
			cookies.remove('user', { path: '/' });
			cookies.remove('token', { path: '/' });
		}

		return Promise.reject(error);
	}
);

export default authAxios;
